/**
* Template Name: NiceAdmin - v2.3.1
* Template URL: https://bootstrapmade.com/nice-admin-bootstrap-admin-html-template/
* Author: BootstrapMade.com
* License: https://bootstrapmade.com/license/
*/
import { toHalfWidth } from "./common";
(function() {
  "use strict";

  /**
   * Easy selector helper function
   */
  const select = (el, all = false) => {
    el = el.trim()
    if (all) {
      return [...document.querySelectorAll(el)]
    } else {
      return document.querySelector(el)
    }
  }

  /**
   * Easy event listener function
   */
  const on = (type, el, listener, all = false) => {
    if (all) {
      select(el, all).forEach(e => e.addEventListener(type, listener))
    } else {
      select(el, all).addEventListener(type, listener)
    }
  }

  /**
   * Easy on scroll event listener 
   */
  const onscroll = (el, listener) => {
    el.addEventListener('scroll', listener)
  }

  /**
   * Sidebar toggle
   */
  if (select('.toggle-sidebar-btn')) {
    on('click', '.toggle-sidebar-btn', function(e) {
      select('body').classList.toggle('toggle-sidebar')
    })
  }

  /**
   * Toggle .header-scrolled class to #header when page is scrolled
   */
  let selectHeader = select('#header')
  if (selectHeader) {
    const headerScrolled = () => {
      if (window.scrollY > 100) {
        selectHeader.classList.add('header-scrolled')
      } else {
        selectHeader.classList.remove('header-scrolled')
      }
    }
    window.addEventListener('load', headerScrolled)
    onscroll(document, headerScrolled)
  }
})();

$.fn.extend({
  numberformat: function(){
    $.each(this, function(index, _this){
      const cloneEl = $(_this).clone()
      const cloneId = `${$(_this).attr('id')}_clone`
      $(cloneEl).attr({id: cloneId, name: '', autocomplete: 'off'})
      $(_this).attr('type', 'hidden')
      $(_this).after(cloneEl)
      const val = Number($(cloneEl).val())
      if(val){
        $(cloneEl).val(val.toLocaleString())
      }

      $(cloneEl).on('focus', function(e){
        const val = $(this).val()
        if(val){
          const removed = Number(val.replace(',', ''))
          if(removed){
            $(this).val(removed)
          }
          $(cloneEl).trigger('select')
        }
        $(cloneEl).removeAttr('placeholder')
      })

      $(cloneEl).on('blur', function(e){
        const val = $(this).val()
        const halfWidthStr = toHalfWidth(val)
        const num = Number(halfWidthStr)
        if(num){
          $(this).val(num.toLocaleString())
          $(_this).val(num)
        }else{
          $(_this).val(val)
        }
        $(cloneEl).attr('placeholder', $(_this).attr('placeholder'))
      });

      $(cloneEl).on('keyup', function(e){
        const val = $(this).val()
        const halfWidthStr = toHalfWidth(val)
        const num = Number(halfWidthStr)
        if(num){
          $(_this).val(num)
        }else{
          $(_this).val(val)
        }
      });
      $(cloneEl).on('click', function(e){
        $(this).trigger('select')
      })
    })
  }
});
$.ajaxSetup({
  cache: false,
  headers: { // リクエストヘッダーの設定
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  },
  beforeSend: () => { // リクエストする前の処理
    // ローディングアイコンを表示する
    const loadingEl = $('.loading')
    if(loadingEl.hasClass('d-none')){
      loadingEl.removeClass('d-none')
    }
  },
  complete: () => { // リクエスト完了した後の処理
    // ローディングアイコンを非表示する
    const loadingEl = $('.loading')
    loadingEl.addClass('d-none')
  }
});

// 非同期処理(axios)の入口
window.axios.interceptors.request.use(config => {
  const loadingEl = $('.loading')
  if(loadingEl.hasClass('d-none')){
    loadingEl.removeClass('d-none')
  }
  return config;
});

// 非同期処理(axios)の出口
window.axios.interceptors.response.use(response => {
  const loadingEl = $('.loading')
    loadingEl.addClass('d-none')
  return response;
}, error => {
    const loadingEl = $('.loading')
    loadingEl.addClass('d-none')
});